export default __webpack_public_path__ + "static/media/vn.ba3a22e4.svg";